module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0",
      "height": "100%"
    }
  }, [_c('van-cell-group', [_c('van-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('van-field', {
    attrs: {
      "name": "身份证号",
      "label": "身份证号",
      "clearable": "",
      "placeholder": "请输入身份证号",
      "rules": [{
        required: true,
        message: '身份证号'
      }]
    },
    model: {
      value: (_vm.formData.id_code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id_code", $$v)
      },
      expression: "formData.id_code"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "姓名",
      "label": "姓名",
      "clearable": "",
      "placeholder": "请输入姓名",
      "rules": [{
        required: true,
        message: '姓名'
      }]
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "16px"
    }
  }, [(!_vm.saveLoading) ? _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "native-type": "submit"
    }
  }, [_vm._v("\n                    登陆\n                ")]) : _c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "loading": true,
      "loading-text": "登陆中..."
    }
  }, [_vm._v("\n                    登陆中...\n                ")])], 1)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10890d62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/score/TimeLogin.vue
// module id = 2200
// module chunks = 0